import React from 'react'
import './about-content.scss'
import AboutEvent from '../../molecules/about-event/aboutEvent'
import GuideTo from '../../molecules/guided-to/guideTo'

const aboutContent = props => {
	const { data } = props
	return (
		<div className='m-about-content' id='evento'>
			<AboutEvent aboutInfo={data.sobreElEvento} />
			<GuideTo
				guideInfo={data.dirigidoA}
				colorPrincipal={data.colorPrincipal}
			/>
		</div>
	)
}

export default aboutContent
